/* import __COLOCATED_TEMPLATE__ from './psrr-offset.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();